// Shared, mutable state handed off from a finished round to the
// leaderboard overlay. There's no direct call path between the two (main.js
// writes it in gameScreen's onRoundStart/onRoundFinish/onRoundEnd
// callbacks, leaderboardScreen.js reads it when shown), so this plays the
// role a tiny store would.
// sessionId is the server-tracked round session (see startRound() in
// supabaseClient.js) - leaderboardScreen.js hands it back on submit so the
// elapsed time gets computed server-side instead of trusting elapsedSeconds.
// sessionPromise is the in-flight startRound() call itself (not just its
// eventually-resolved id) - onRoundFinish fires the instant the round is
// decided, which for a fast round could in principle be before startRound()
// has actually resolved, so onRoundFinish chains off this promise rather
// than reading sessionId directly. Reading sessionId there instead would
// risk silently no-op'ing endRound() on a session id that hasn't arrived
// yet, which would reintroduce the exact "displayed time != stored time"
// bug this all exists to prevent.
// endRoundPromise is the in-flight endRound() call kicked off the instant
// the round is decided (see main.js's onRoundFinish, fired synchronously
// from gameScreen.js before the celebratory pause) - main.js's onRoundEnd
// awaits it and uses the server-computed seconds it resolves to (instead
// of the client's own timer) as elapsedSeconds, so "Your time" always
// matches what submit_leaderboard_score() later writes to the leaderboard.
export const runResult = { elapsedSeconds: 0, found: false, sessionId: null, sessionPromise: null, endRoundPromise: null };
